import { render, staticRenderFns } from "./cms-block-menu.vue?vue&type=template&id=188ddb7e&scoped=true"
import script from "./cms-block-menu.vue?vue&type=script&lang=js"
export * from "./cms-block-menu.vue?vue&type=script&lang=js"
import style0 from "./cms-block-menu.vue?vue&type=style&index=0&id=188ddb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ddb7e",
  null
  
)

export default component.exports